import { createSlice } from "@reduxjs/toolkit";

import {
  addUnitUsers,
  deleteUnitUsers,
  getUnitsUsers,
  updateUnitUsers,
} from "./thunk";

interface UnitStateType {
  unitsUsers: Array<any>;
  error?: string | object | null | undefined | unknown;
  success?: string | object | null | undefined | unknown;
}

export const initialState: UnitStateType = {
  unitsUsers: [],
  error: null,
  success: null,
};

const unitsUsersSlice = createSlice({
  name: "unitsUsers",
  initialState,
  reducers: {
    unitsUsersError(state, action) {
      state.error = action.payload;
    },
    unitsUsersSuccess(state, action) {
      state.success = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getUnitsUsers.fulfilled, (state: any, action: any) => {
      state.unitsUsers = action.payload;
    });
    builder.addCase(getUnitsUsers.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(addUnitUsers.fulfilled, (state: any, action: any) => {
      state.unitsUsers.push(action.payload);
    });
    builder.addCase(addUnitUsers.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(updateUnitUsers.fulfilled, (state: any, action: any) => {
      state.unitsUsers = state.unitsUsers.map((unit: any) =>
        unit.id === action.payload.id ? { ...unit, ...action.payload } : unit
      );
    });
    builder.addCase(updateUnitUsers.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(deleteUnitUsers.fulfilled, (state: any, action: any) => {
      state.unitsUsers = state.unitsUsers.filter(
        (unit: any) => unit.id !== action.payload
      );
    });
    builder.addCase(deleteUnitUsers.rejected, (state, action) => {
      state.error = action.payload || null;
    });
  },
});

export const { unitsUsersError, unitsUsersSuccess } = unitsUsersSlice.actions;

export default unitsUsersSlice.reducer;
